import Button from "../../component/button/Button";
import { getLibraryByCategory } from "../../api/HttpApis";
import { trimStr } from "../../utils/theme/ShortenedText/ShortenedText";
import { useState } from "react";
import { CiImageOn } from "react-icons/ci";
import { buildContentCard } from "../../component/ListView/contentCard";

const MediaImage = ({ src, alt }) => {
  const [hasError, setHasError] = useState(false);
  if (hasError || !src) return <CiImageOn size={40} />;
  return (
    <img
      className="imageBox"
      src={src}
      alt={alt || "Media"}
      width={40}
      height={30}
      onError={() => setHasError(true)}
    />
  );
};

const useShortClipsData = () => {
  const shortClipsListData = async (selectedDate, selectedCreator, selectedRating, selectedGenre, page, perpage) => {
    const response = await getLibraryByCategory(
      "Short Clip",
      {},
      selectedDate,
      selectedCreator,
      selectedRating,
      selectedGenre,
      perpage,
      page
    );
    const data = Array.isArray(response?.data?.data) ? response.data.data : [];

    return data?.map((shortClip) => ({
      id:
        shortClip.id ||
        shortClip.original_id ||
        shortClip.video_id ||
        shortClip.movie_id,
      metadata_id:
        shortClip.metadata_id || shortClip.meta_id || shortClip.meta_data_id,
      name: trimStr(shortClip.name),
      media: shortClip.portrait,
      status: shortClip.status,
      qc_status: shortClip.qc_status,
      rating: shortClip.rating,
      access: shortClip.access,
      buttonText: "Edit",
      buttonText2: "Remove",
      totalCount: response?.data?.total,
    }));
  };

  const getColumns = (handleEdit, handleDelete, deletingId) => [
    {
      key: "name",
      label: "Name",
      render: (item) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            display: "block",
            minWidth: 0,
          }}
        >
          {trimStr(item.name, 15)}
        </div>
      ),
    },
    {
      key: "media",
      label: "Media",
      render: (item) => <MediaImage src={item.media} alt={item.name} />,  // ← only this changed
    },
    { key: "status", label: "Status" },
    { key: "rating", label: "Rating" },
    { key: "access", label: "Access" },
    {
      key: "buttonText",
      render: (item) => (
        <Button onClick={() => handleEdit(item.id, item.metadata_id)}>
          {item.buttonText}
        </Button>
      ),
    },
    {
      key: "buttonText2",
      render: (item) => (
        <Button
          onClick={() => handleDelete(item.id, item.metadata_id)}
          loading={deletingId === (item.metadata_id || item.id)}
          disabled={deletingId === (item.metadata_id || item.id)}
        >
          {item.buttonText2}
        </Button>
      ),
    },
  ];

  return {
    shortClipsListData,
    getColumns,
    getCard: buildContentCard,
  };
};

export default useShortClipsData;